module.exports = __webpack_public_path__ + "static/img/Arrow.0fd4f1fe.svg";